var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-empty-state',_vm._b({staticClass:"binds-table-empty-state"},'binds-empty-state',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }